export const iconFontAwesomeCommunicationPaperPlane = (
	<i className="fa-solid fa-paper-plane"></i>
);
